import React, { useCallback, useEffect, useMemo, useState } from 'react';
import {Chip, Container, Grid, Typography } from '@material-ui/core';
import { Table } from 'components';
import { useStyles } from '../styles/styles';
import TableLoader from 'views/SalesReports/components/skletons/TableLoader';
import SearchBar from 'material-ui-search-bar';
import { Alert } from '@material-ui/lab';
import { routes } from 'utils/routers.constants';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { asyncWebhookNotifications } from 'store/reducers/paymentPlan.reducer';
import { useDispatch, useSelector } from 'react-redux';
import { format, parseISO } from 'date-fns';

export const status = {
  error: 'Erro',
  success: 'Sucesso',
}

export const statusColor = {
  error: '#FFCCCB',
  success: '#A0C8A0'
}

const Webhooks = () => {
    const classes = useStyles();
    const history = useHistory();
    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [search, setSearch] = useState('');
    const dispatch = useDispatch();
    const { webhookNotifications, loading } = useSelector((state) => state.PaymentPlan);

    const columns = [
      { id: 'id', label: 'ID', minWidth: 170, orderable: false},
      { id: 'baseURL', label: 'Endpoint', minWidth: 170, orderable: false},
      { id: 'status', label: 'Status', minWidth: 130, orderable: false},
      { id: 'created_at', label: 'Criado em', minWidth: 130, orderable: false},
    ];

    const webhookNotificationsFormated = useMemo(() => {
      if (webhookNotifications) {
        return webhookNotifications?.items?.map(notification => ({
          id: notification?.id,
          status: <Chip label={status?.[notification?.status]} style={{background: statusColor?.[notification?.status]}}/> ,
          baseURL: notification?.request?.baseURL,
          created_at: format(parseISO(notification?.created_at), "dd/MM/yyyy 'às' HH:mm"),
        }));
      }
      return [];
    }, [webhookNotifications]);

    const handleGetWebhooks = useCallback(() => {
        dispatch(asyncWebhookNotifications({page, pageSize, search}));
    }, [dispatch, page, pageSize, search]);

    useEffect(() => {
      handleGetWebhooks();
    }, [handleGetWebhooks]);

    const handleRead = (row) => {
      const url = `${routes.PLAN_WEBHOOK_DETAILS.replace(':id', row.id)}`;
      history.push(url);
    }

    const handleCurrentPage = (page) => {
      setPage(page);
    };

    const handlePageSize = (pageSize) => {
      setPageSize(pageSize);
      setPage(0);
    };

    return (
      <Container className={classes.main} maxWidth="xl" component='main'>
        <Grid
          container
          component='header'
          direction="row"
          justify="space-between"
          alignItems="center"
          className={classes.header}
        >
          <Typography variant="h4" component="span" className={classes.title_header}>
            Webhook
          </Typography>
        </Grid>
        <SearchBar
          value={search}
          placeholder='Buscar pelo endpoint'
          className={classes.search}
          onChange={(text) => {
            setPage(0);
            setSearch(text);
          }}          
          onCancelSearch={() => {
            setPage(0);
            setSearch('')
          }}
        />   
        
        <WebhookTable
          action={true}
          actionButton="Visualizar"
          onClickDetails = {handleRead}
          columns={columns}
          rows={webhookNotificationsFormated}
          selectRow={false}
          currentPage={page}
          pageSize={pageSize}
          basicPagination={false}
          rowsPerPageOptions={[10, 25, 50]}
          onCurrentPage={handleCurrentPage}
          onPageSize={handlePageSize}
          count={webhookNotifications?.total}
          loading={loading}
        />     
      </Container>
    )
  }
  
export default Webhooks;

const WebhookTable = ({loading, rows, ...props}) => {
  const classes = useStyles();

  if (loading || !rows) {
    return <TableLoader />
  }

  if (!rows?.length) {
    return <Alert severity="info" className={classes.alert}>Nenhum registro encontrado!</Alert>
  }

  return (
    <Table
      rows={rows}
      {...props}
    />
  )
}

